import React, { useState, useRef, useMemo } from 'react';
import { nanoid } from 'nanoid';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useClickAway } from 'react-use';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var _excluded$1 = ["children", "heading", "toggleMenu", "isFocused", "disabled", "readonly", "invalid", "hasSelection", "valid"];

function DropToggle(props) {
  var children = props.children,
      heading = props.heading,
      toggleMenu = props.toggleMenu,
      isFocused = props.isFocused,
      disabled = props.disabled,
      readonly = props.readonly,
      invalid = props.invalid,
      hasSelection = props.hasSelection,
      valid = props.valid,
      attributes = _objectWithoutProperties(props, _excluded$1);

  var isValid = valid || valid === 'true';
  var isInvalid = invalid || invalid === 'true';
  var isDisabled = disabled || disabled === 'true';
  var isReadonly = readonly || readonly === 'true';
  var buttonClass = classNames('prism-select__toggle', 'form-control', isFocused && 'focus', isDisabled && 'is-disabled', isInvalid && 'is-invalid', isValid && 'is-valid', isReadonly && 'is-readonly');

  function handleClick() {
    toggleMenu();
  }

  return /*#__PURE__*/React.createElement("button", _extends({
    "aria-controls": "listbox",
    type: "button",
    disabled: isDisabled,
    className: buttonClass,
    onClick: function onClick() {
      return handleClick();
    }
  }, attributes), /*#__PURE__*/React.createElement("div", {
    className: "prism-select__label",
    style: {
      opacity: hasSelection ? 1 : 0.5
    },
    title: children || heading
  }, children || heading));
}

/* eslint-disable react/jsx-filename-extension */
var propTypes$2 = {
  className: PropTypes.string,
  selectOption: PropTypes.func,
  isSelected: PropTypes.bool,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.array]),
  disabled: PropTypes.bool,
  group: PropTypes.string,
  handleClick: PropTypes.func
};
var defaultProps$2 = {
  selected: [],
  selectOption: function selectOption() {},
  disabled: false,
  isSelected: false,
  handleClick: function handleClick() {}
};

var DrOption = function DrOption(props) {
  var buttonRef = React.useRef(null); // gets a name prop.string, value prop.string, selectOption prop.func, selected prop.sting || prop.number

  var name = props.name,
      children = props.children,
      value = props.value;
      props.selectOption;
      var isSelected = props.isSelected,
      disabled = props.disabled,
      group = props.group,
      id = props.id,
      handleClick = props.handleClick;
  var getName = name || children;
  var getValue = value || getName;
  var getId = id || getName; // when prop.selected === prop.value, add active class modifier.

  var optionClass = classNames('prism-select__option', isSelected && 'prism-select__option-selected', disabled && 'prism-select__option-disabled');
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: optionClass,
    onClick: function onClick() {
      return handleClick(value);
    },
    ref: buttonRef,
    selected: isSelected,
    value: getValue,
    disabled: disabled,
    name: getName,
    title: getName,
    id: getId,
    group: group
  }, /*#__PURE__*/React.createElement("span", {
    title: getName,
    className: "prism-select__label"
  }, getName));
};

DrOption.propTypes = propTypes$2;
DrOption.defaultProps = defaultProps$2;

var _excluded = ["open", "selected", "selectOption", "children", "placeholder", "options", "heading"];
var propTypes$1 = {
  className: PropTypes.string,
  open: PropTypes.bool,
  selectOption: PropTypes.func,
  options: PropTypes.array,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.array])
};
var defaultProps$1 = {
  open: false,
  options: null
};

function DropdownMenu(props) {
  // receive options from Dropdown component
  var open = props.open,
      selected = props.selected,
      selectOption = props.selectOption,
      children = props.children,
      placeholder = props.placeholder,
      options = props.options;
      props.heading;
      var attributes = _objectWithoutProperties(props, _excluded);

  var menuClass = classNames("prism-select__menu-".concat(open ? 'open' : 'closed'));

  var childrenWithProps = React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      selectOption: selectOption,
      selected: selected,
      label: child.props.label || child.props.name || placeholder,
      disabled: child.props.disabled,
      id: child.props.id || null,
      children: child.props.children
    });
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    role: "listbox",
    className: menuClass
  }, attributes), options && placeholder || /*#__PURE__*/React.createElement("span", {
    className: "prism-select__menu-heading"
  }, placeholder), childrenWithProps);
}

DropdownMenu.propTypes = propTypes$1;
DropdownMenu.defaultProps = defaultProps$1;

var propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  selectOption: PropTypes.func,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.object, PropTypes.array])
};
var defaultProps = {
  label: 'Select One ...'
};

function DrOptionGroup(props) {
  var children = props.children,
      label = props.label,
      selectOption = props.selectOption,
      selected = props.selected,
      options = props.options;

  var normalizeOptions = function normalizeOptions(options, label, selected, selectOption) {
    return options.map(function (option) {
      return /*#__PURE__*/React.createElement(DrOption, {
        selectOption: selectOption,
        selected: selected,
        group: label,
        name: option.name,
        value: option.value,
        key: option.name,
        disabled: option.disabled
      });
    });
  };

  var childrenWithProps = React.Children.map(children, function (child) {
    return /*#__PURE__*/React.cloneElement(child, {
      selectOption: selectOption,
      selected: selected,
      name: child.props.name,
      group: label,
      value: child.props.value,
      disabled: child.props.disabled,
      children: child.props.children
    });
  }); // if passed children, render children, else if passed options render options, else null

  var renderOptions = children ? childrenWithProps : options && normalizeOptions(options, label, selected, selectOption);
  return /*#__PURE__*/React.createElement("div", {
    className: "prism-select__option-group"
  }, /*#__PURE__*/React.createElement("span", {
    className: "prism-select__option-group-label"
  }, label), renderOptions);
}

DrOptionGroup.propTypes = propTypes;
DrOptionGroup.defaultProps = defaultProps;

var Dropdown = function Dropdown(props) {
  var multiple = props.multiple,
      placeholder = props.placeholder,
      propOnChange = props.onChange,
      propOptions = props.options,
      propsValid = props.valid,
      propsInvalid = props.invalid,
      propIsOpen = props.isOpen,
      defaultSelection = props.defaultSelection,
      disabled = props.disabled,
      readonly = props.readonly,
      containerClasses = props.containerClasses,
      size = props.size,
      propChildren = props.children,
      style = props.style;

  var _useState = useState(defaultSelection),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = useState(propIsOpen),
      _useState4 = _slicedToArray(_useState3, 2),
      isOpen = _useState4[0],
      setIsOpen = _useState4[1]; // props.isOpen


  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isFocused = _useState6[0],
      setIsFocused = _useState6[1];

  var ref = useRef(null);

  function dismiss() {
    setIsOpen(false);
    setIsFocused(false);
  }

  function getPropsFromArg() {
    if (!propOptions) return [];

    var stringAsProps = function stringAsProps(option, sIdx) {
      return {
        value: "".concat(option),
        label: "".concat(option),
        id: nanoid(),
        name: "".concat(option),
        key: "".concat(sIdx, " - ").concat(option),
        isSelected: selected.includes(option)
      };
    };

    var objAsProps = function objAsProps(option, osIdx) {
      return _objectSpread2(_objectSpread2({}, option), {}, {
        value: option.value,
        label: option.name || option.value,
        id: nanoid(),
        name: option.name || option.value,
        key: "".concat(osIdx, " - ").concat(option.id || option.value),
        isSelected: selected.includes(option)
      });
    };

    return propOptions.map(function (opt, idx) {
      if (typeof opt === 'string') {
        return stringAsProps(opt, idx);
      }

      return objAsProps(opt, idx);
    });
  }

  function getPropsFromChild(child, idx) {
    var _child$props = child.props,
        label = _child$props.label,
        children = _child$props.children;
    var isGroup = label && children;

    var childAsProps = function childAsProps(elem, elemIdx) {
      var _elem$props = elem.props,
          id = _elem$props.id,
          name = _elem$props.name,
          value = _elem$props.value,
          innerText = _elem$props.children;
      return _objectSpread2(_objectSpread2({}, elem.props), {}, {
        id: id || value,
        key: "".concat(elemIdx, " - ").concat(id || value, "-").concat(nanoid()),
        name: name || innerText || value,
        value: value || innerText || name || id,
        isSelected: selected.includes(value)
      });
    };

    var groupAsProps = function groupAsProps(groupLabel, groupChildren) {
      var list = React.Children.toArray(groupChildren);
      var items = list.map(childAsProps);
      return {
        label: groupLabel,
        key: nanoid(),
        items: items
      };
    };

    return isGroup ? groupAsProps(label, children) : childAsProps(child, idx);
  }

  function toggleSelection(val) {
    var alreadySelected = selected.includes(val);

    if (multiple) {
      if (alreadySelected) {
        setSelected(selected.filter(function (s) {
          return s !== val;
        }));
      } else {
        setSelected([].concat(_toConsumableArray(selected), [val]));
      }
    } else if (!alreadySelected) {
      setSelected([val]);
      dismiss();
    }
  }

  var tree = useMemo(function () {
    var jsxChildren = React.Children.toArray(propChildren);
    var jsxOptions = jsxChildren.map(getPropsFromChild);
    var argOptions = getPropsFromArg();
    return [].concat(_toConsumableArray(jsxOptions), _toConsumableArray(argOptions));
  }, [selected]);

  var _useMemo = useMemo(function () {
    var _ref;

    function handleOptionClick(val) {
      toggleSelection(val);

      var _options$find = options.find(function (i) {
        return i.value === val;
      }),
          name = _options$find.name,
          isSelected = _options$find.isSelected;

      propOnChange({
        val: val,
        name: name,
        isSelected: isSelected,
        multiple: multiple
      });
    }

    var newOptions = (_ref = []).concat.apply(_ref, _toConsumableArray(tree.map(function (item) {
      return item.items ? item.items : item;
    })));

    return {
      options: newOptions,
      renderList: /*#__PURE__*/React.createElement(React.Fragment, null, tree.map(function (i) {
        if (i.items) {
          return /*#__PURE__*/React.createElement(DrOptionGroup, {
            key: "group-".concat(i.label),
            label: i.label
          }, i.items.map(function (item) {
            return /*#__PURE__*/React.createElement(DrOption, _extends({
              key: item.key
            }, item, {
              handleClick: function handleClick(v) {
                return handleOptionClick(v);
              }
            }));
          }));
        }

        return /*#__PURE__*/React.createElement(DrOption, _extends({
          key: i.key
        }, i, {
          handleClick: function handleClick(v) {
            return handleOptionClick(v);
          }
        }));
      })),
      heading: newOptions.filter(function (i) {
        return selected.includes(i.value);
      }).map(function (i) {
        return i.name;
      }).join(', ')
    };
  }, [tree]),
      options = _useMemo.options,
      renderList = _useMemo.renderList,
      heading = _useMemo.heading;
  /** Always close the dropdown when clicking outside */


  useClickAway(ref, function () {
    dismiss();
  });
  var dropdownClass = classNames('prism-select', "prism-select-".concat(size), _toConsumableArray(containerClasses));
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: dropdownClass,
    style: style
  }, /*#__PURE__*/React.createElement(DropToggle, {
    isFocused: isFocused,
    hasSelection: JSON.stringify(heading) !== '""',
    heading: heading || placeholder,
    disabled: disabled,
    readonly: readonly,
    invalid: propsInvalid,
    valid: propsValid,
    toggleMenu: function toggleMenu() {
      return setIsOpen(!isOpen);
    }
  }), /*#__PURE__*/React.createElement(DropdownMenu, {
    key: nanoid(),
    open: isOpen,
    heading: placeholder,
    placeholder: placeholder || 'Select One...'
  }, renderList), /*#__PURE__*/React.createElement("input", {
    type: "hidden",
    title: "dropdown-input-value",
    value: selected
  }));
};

Dropdown.propTypes = {
  /**
   * Standard HTML ID attribute.
   */
  id: PropTypes.string,
  children: PropTypes.node,

  /**
   * Standard HTML placeholder text to display before user input.
   */
  placeholder: PropTypes.string,

  /**
   * If true, the dropdown will be disabled and interaction limited.
   */
  disabled: PropTypes.bool,

  /**
   * If true, the dropdown will be readonly and interaction limited.
   */
  readonly: PropTypes.bool,

  /**
   * If true, behavior will be adjusted to allow multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * Allow the dropdown to initially display open. Has no effect after initial rendering. **Controlled**
   */
  isOpen: PropTypes.bool,

  /**
   * If true, the dropdown will act as if it has a valid input initially. **Controlled**
   */
  valid: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  /**
   * If true, the dropdown will act as if it has an invalid input initially. **Controlled**
   */
  invalid: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),

  /**
   * Optionally append classnames to the container element - this does not override the default classnames.
   */
  containerClasses: PropTypes.string,

  /**
   * Optional callback for when the selected values change. Four arguments are passed:
   * onChange({ value, name, selected, multiple });
   * value of item, name of item, is it selected, are multiple allowed (true/false)
   * */
  onChange: PropTypes.func,

  /**
   * Optionally indicate initial select by passing an array of values found in children.
   */
  defaultSelection: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.number)]),

  /** Rather than children, options can be passed as an array. Recommended. */
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.number), PropTypes.arrayOf(PropTypes.object)]),

  /** Size, optionally render a smaller version */
  size: PropTypes.oneOf(['sm', 'md']),

  /** Optionally inject CSS as modules */
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};
Dropdown.defaultProps = {
  multiple: false,
  isOpen: false,
  id: nanoid(),
  defaultSelection: [],
  containerClasses: '',
  children: [],
  options: undefined,
  onChange: function onChange() {
    return true;
  },
  valid: null,
  invalid: null,
  disabled: false,
  readonly: false,
  placeholder: 'Select One...',
  size: 'md',
  style: {}
};

if (Dropdown) {
  Dropdown.Menu = DropdownMenu;
  Dropdown.Option = DrOption;
  Dropdown.OptionGroup = DrOptionGroup;
  Dropdown.Toggle = DropToggle;
}

export { DrOption, DrOptionGroup, DropToggle, DropdownMenu, Dropdown as default };
//# sourceMappingURL=index.js.map
